import {
  type RowActionsProps,
  type SearchAndFiltersProps,
  type StyleConfigProps,
  type VisibilityElementProps,
  type WrappedElementProps,
} from '@blaze-runtime/engine-domain';
import {
  type BorderRadiusValue,
  type CanvasElementPropertiesWithData,
  type ElementLabelProps,
  type ElementTitleStyleProps,
  type PropertiesConfigInputColorModel,
  type PropertiesConfigInputColorPaletteModel,
  type PropertiesConfigInputColumnModel,
  type PropertiesConfigInputGanttChartFieldModel,
  type PropertiesConfigInputListCustomFieldModel,
  type PropertiesConfigInputSpacingAndAlignmentModel,
  type PropertiesConfigInputVisualEffectModel,
} from '@blaze-shared/elements-domain';
import { type ValueWithUnitOfMeasure } from '@blaze-shared/shared-util';

type PropsModel = CanvasElementPropertiesWithData &
  WrappedElementProps &
  SearchAndFiltersProps &
  StyleConfigProps &
  VisibilityElementProps &
  RowActionsProps;

export enum GanttChartTimeScale {
  Day = 'day',
  Week = 'week',
  Month = 'month',
}

// matches date.getDay() values
export enum GanttChartDay {
  Monday = 1,
  Saturday = 6,
  Sunday = 0,
}

export type GanttChartPropsModel = PropsModel & {
  content: {
    columns: PropertiesConfigInputColumnModel[];
    fields: PropertiesConfigInputGanttChartFieldModel;
    customFields: PropertiesConfigInputListCustomFieldModel[];
    title: ElementLabelProps;
    options: {
      timeScale: GanttChartTimeScale;
      startWeekOn: GanttChartDay;
    };
  };
  style: {
    fontSize: ValueWithUnitOfMeasure;
    fontFamily: string;
    lineHeight: ValueWithUnitOfMeasure;
    general: {
      offset: PropertiesConfigInputSpacingAndAlignmentModel;
      visualEffect: PropertiesConfigInputVisualEffectModel;
    };
    title: {
      text: PropertiesConfigInputColorModel;
    };
    titleBlock: ElementTitleStyleProps;
    headers: {
      text: PropertiesConfigInputColorModel;
      background: PropertiesConfigInputColorModel;
      accent: PropertiesConfigInputColorModel;
      width?: ValueWithUnitOfMeasure;
    };
    table: {
      text: PropertiesConfigInputColorModel;
      background: PropertiesConfigInputColorModel;
      lines: PropertiesConfigInputColorModel;
      radius: BorderRadiusValue;
      hideColumnsBorder: boolean;
    };
    bar: {
      palette: PropertiesConfigInputColorPaletteModel;
    };
    container: {
      outline: PropertiesConfigInputColorModel;
      outlineWidth: ValueWithUnitOfMeasure;
    };
  };
};
